<template>
  <div class="all-wrapper" ref="pageView">
    <section class="title">
      <div class="title-name">
        企业信用明细
      </div>
      <!-- <div class="tool-bar" >
              <i class=" export-btn e6-icon-export_line"></i>
            </div> -->
    </section>

    <!--主体 start-->
    <section class="main-content clearfix">
      <!--左侧搜索栏 start-->
      <section class="g-form-section form-section fixed-view search-wrapper">
        <e6-form-extend
          class="e6-form--validate"
          :formExtend="formExtend"
          ref="searchForm"
          :rules="rules"
        >
          <template slot-scope="slotForms">
            <el-form-item class="form-item">开始时间</el-form-item>
            <el-form-item prop="forms.beginTime">
              <el-date-picker
                v-model="slotForms.forms.beginTime"
                type="date"
                placeholder="选择开始日期"
                value-format="timestamp"
                :picker-options="bTimePickerOptions"
                @change="selectbTime"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item class="form-item">结束时间</el-form-item>
            <el-form-item prop="forms.endTime">
              <el-date-picker
                v-model="slotForms.forms.endTime"
                type="date"
                placeholder="选择结束日期"
                value-format="timestamp"
                :picker-options="eTimePickerOptions"
                @change="selecteTime"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item class="form-item">企业</el-form-item>
            <el-form-item prop="forms.comparyId">
              <el-select
                v-model="slotForms.forms.comparyId"
                placeholder="企业名称"
                filterable
                clearable
              >
                <el-option
                  v-for="item in allComparys"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-button
              type="primary"
              icon="e6-icon-search_line"
              class="query-btn"
              @click="handlesSubmitForm"
              >查询
            </el-button>
          </template>
          <!-- <template slot="submit">
                      <i class="e6-icon-search_line"></i>查询
                    </template> -->
        </e6-form-extend>
      </section>
      <!--左侧搜索栏 end-->

      <!--右侧企业信用明细画像展示部分 start-->
      <section
        class="figure-content"
        v-loading="loading"
        element-loading-text="数据加载中"
      >
        <div class="figure-data" v-show="firstEnter">
          <div class="nodate">
            <img src="../../../assets/images/pg-search.png" alt="" />
          </div>
        </div>
        <div class="figure-data" v-if="hasMessage">
          <!--基础信息-姓名、得分 start-->
          <section class="base-info-ctn">
            <div class="base-info">
              <div class="compary-logo">
                <img
                  class="photo"
                  src="../../../assets/images/company.png"
                  alt=""
                />
              </div>
              <div class="info">
                <div class="name-date">
                  <span class="name">{{ radarData.comparyName }}</span>
                  <span class="date">
                    {{ showTime }}
                  </span>
                </div>
                <div class="org-list">
                  <span>企业排名: {{ radarData.orderIndex }}</span>
                </div>
              </div>
            </div>
            <div class="synthesis-score">
              <span class="synthesis">信用综合得分</span>
              <span
                class="score"
                :class="setScoreColor(radarData.totalScope)"
                >{{ radarData.totalScope }}</span
              >
            </div>
          </section>
          <!--基础信息-姓名、得分 end-->
          <section class="figures">
            <!--雷达图 start-->
            <section class="chart-ctn">
              <div class="chart-wrapper">
                <div class="radar-chart" ref="radarChartDom"></div>
              </div>
            </section>
            <!--雷达图 end-->

            <!-- 周得分曲线 start -->
            <section class="chart-ctn">
              <div class="chart-title">
                <span class="line-title">周得分曲线</span>
              </div>
              <div class="chart-wrapper">
                <div class="line-chart" ref="lineChartDom"></div>
              </div>
            </section>
            <!-- 周得分曲线 end -->

            <!-- 企业行为分析 start -->
            <section class="chart-ctn behaver-ctn">
              <div class="chart-title behaver">
                <span class="line-title">企业行为分析</span>
              </div>
              <div class="table-wrapper">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  class="tab-con"
                >
                  <el-table-column
                    prop="behaviorRanking"
                    label="行为排名"
                    width="180"
                    align="center"
                    header-align="center"
                    class-name="t-rank"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="behaviorName"
                    label="行为名称"
                    width="300"
                    align="center"
                    header-align="center"
                    class-name="t-name"
                  >
                  </el-table-column>
                  <el-table-column
                    label="行为得分"
                    class-name="t-score"
                    align="center"
                    header-align="center"
                  >
                    <template slot-scope="scope">
                      <span :class="setColor(scope.row)">{{
                        scope.row.behavioralScore
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="totalAverage"
                    label="郑州市各企业平均值"
                    align="center"
                    header-align="center"
                    class-name="t-average"
                  ></el-table-column>
                </el-table>
              </div>
            </section>
            <!-- 企业行为分析 end -->
          </section>
        </div>
        <div class="figure-data" v-else>
          <div class="nodate">
            <img src="../../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
      </section>
      <!--右侧企业信用明细画像展示部分 end-->
    </section>
    <!--主体 end-->
  </div>
</template>

<script type="text/babel">
import Echarts from "echarts";
import { FetchFindByPage } from "@/api/comparyCredit/detail";
import { FetchAllComparys } from "_private/api/systemSetting/userManage";
import resizeListener from "_private/mixins/resizeListener";

export default {
  mixins: [resizeListener],
  data() {
    return {
      loading: false,
      firstEnter: true,
      showTime: "", //标题企业名称下展示的时间
      formExtend: {
        forms: {
          comparyId: "", //企业名称
          beginTime: "", //查询时间范围
          endTime: ""
        },
        extends: []
      },
      //雷达图数据
      radarData: {},
      //折线图数据
      lineDate: [], //横轴时间
      lineNum: [], //纵轴数据
      maxNum: 100,
      minNum: 0,
      //企业行为排行数据
      tableData: [],
      bTimePickerOptions: {
        disabledDate(time) {
          let lastSunday =
            new Date().getTime() - new Date().getDay() * 24 * 60 * 60 * 1000;
          return time.getTime() > lastSunday || time.getDay() !== 1;
        }
      }, //开始时间只让选本周之前的周一
      eTimePickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date().getTime() || time.getDay() !== 0;
        }
      }, //结束时间只让选本周之前的周日
      hasMessage: true,
      allComparys: [], //所有企业名称
      radar: null, //雷达图对象
      line: null, //曲线图对象
      resizeTimer: null, // resize事件节流timer
      rules: {
        "forms.beginTime": [{ required: true, message: "开始时间不能为空" }],
        "forms.endTime": [{ required: true, message: "结束时间不能为空" }],
        "forms.comparyId": [{ required: true, message: "企业名称不能为空" }]
      }
    };
  },
  methods: {
    //获取页面数据
    FetchFindByPage(response) {
      this.loading = true;
      this.firstEnter = false;
      this.lineDate = [];
      this.lineNum = [];
      FetchFindByPage(response)
        .then(response => {
          if (response.code === 1 && Object.keys(response.result).length) {
            this.hasMessage = true;
            if (response.result.comparyCreditDetail) {
              this.radarData = response.result.comparyCreditDetail;
            }
            if (
              response.result.last7WeekCreditScope &&
              Array.isArray(response.result.last7WeekCreditScope)
            ) {
              response.result.last7WeekCreditScope.forEach(item => {
                this.lineDate.push(item.dateSection);
                this.lineNum.push(item.fractionNum);
              });

              let arrNum = [...this.lineNum].sort((a, b) => {
                return a - b;
              });

              this.minNum = (arrNum[0] / 10) * 10;
              this.maxNum =
                arrNum[arrNum.length - 1] === 100
                  ? 100
                  : (arrNum[arrNum.length - 1] / 10) * 10 + 10;
            }
            if (
              response.result.behaviorAnalysis &&
              Array.isArray(response.result.behaviorAnalysis)
            ) {
              this.tableData = response.result.behaviorAnalysis;
            }
            this.showTime =
              this.timestampToTime(this.formExtend.forms.beginTime) +
              "至" +
              this.timestampToTime(this.formExtend.forms.endTime);
            this.initRadarChart();
            this.initLineChart();
          } else {
            this.hasMessage = false;
            this.$message.warnning("暂无数据");
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sortFun(a, b) {
      return a - b;
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      return Y + M + D;
    },
    //选择了周一，结束时间自动选择该周天
    selectbTime(val) {
      if (val) {
        this.formExtend.forms.endTime = val + 6 * 24 * 60 * 60 * 1000;
      } else {
        this.formExtend.forms.endTime = val;
      }
    },
    //选择了周天，开始时间自动选择该周一
    selecteTime(val) {
      if (val) {
        this.formExtend.forms.beginTime = val - 6 * 24 * 60 * 60 * 1000;
      } else {
        this.formExtend.forms.beginTime = val;
      }
    },
    //resize事件
    resizeListener() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.radar && this.radar.resize();
          this.line && this.line.resize();
        });
      }, 300);
    },
    //初始化雷达图
    initRadarChart() {
      this.radar = Echarts.init(this.$refs.radarChartDom);
      const optionR = {
        radar: {
          indicator: [
            {
              name:
                "企业信息备案完整度(40分)：" +
                (this.radarData.filingInfoCompleteScope || 0),
              max: 40
            },
            {
              name:
                "场景信息完整度(10分)：" +
                (this.radarData.sceneInfoCompleteScope || 0),
              max: 10
            },
            {
              name:
                "场景动态数据接入完整度(10分)：" +
                (this.radarData.sceneIotDataScope || 0),
              max: 10
            },
            {
              name:
                "监控设置规范度(10分)：" +
                (this.radarData.monitSettingScope || 0),
              max: 10
            },
            {
              name:
                "企业综合合格率(10分)：" +
                (this.radarData.comparyPassRateScope || 0),
              max: 10
            },
            {
              name:
                "企业综合在线率(20分)：" +
                (this.radarData.comparyOnlineRateScope || 0),
              max: 20
            }
          ],
          center: ["50%", "50%"],
          radius: "80%",
          startAngle: 90,
          splitNumber: 5, //指示器轴分格段数
          nameGap: 15, //指示器名称与指示器轴之间的距离
          shape: "circle",
          name: {
            //   formatter: "value", //指示器名称显示格式
            textStyle: {
              fontSize: 16,
              color: "#666666"
            }
          },
          splitArea: {
            areaStyle: {
              color: ["#FFF", "#FFF", "#FFF", "#FFF"] //分隔区域颜色 由里到外
            }
          },
          axisLine: {
            lineStyle: {
              color: "rgba(205, 205, 205, 0.5)"
            }
          },
          splitLine: {
            lineStyle: {
              color: "rgba(205, 205, 205, 0.5)"
            }
          }
        },
        series: [
          {
            type: "radar",
            color: "#fff",
            symbol: "none",
            itemStyle: {
              normal: {
                color: "#fff"
              }
            },
            areaStyle: {
              // 径向渐变，前三个参数分别是圆心 x, y 和半径，取值同线性渐变
              color: {
                type: "radial",
                x: 0.5,
                y: 0.55,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "#b5d8ff" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#2d8bf5" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }, //连接区域内颜色
            data: [
              {
                value: [
                  this.radarData.filingInfoCompleteScope,
                  this.radarData.sceneInfoCompleteScope,
                  this.radarData.sceneIotDataScope,
                  this.radarData.monitSettingScope,
                  this.radarData.comparyPassRateScope,
                  this.radarData.comparyOnlineRateScope
                ]
              }
            ]
          }
        ]
      };
      this.radar.setOption(optionR);
    },
    //初始化周得分曲线
    initLineChart() {
      this.line = Echarts.init(this.$refs.lineChartDom);
      const optionL = {
        grid: {
          left: 35,
          right: 35,
          top: 50
        },
        tooltip: {
          show: true,
          trigger: "item",
          formatter: "{b}<br />周得分：{c}"
        },
        xAxis: {
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#e7eef6"
            },
            onZero: true
          },
          axisLabel: {
            fontSize: 12,
            color: "#90939a",
            interval: 0,
            formatter: function(value) {
              let arr = value.split("至");
              return arr[0] + "\n" + "~" + "\n" + arr[1];
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#e7eef6"
            }
          },
          data: this.lineDate
        },
        yAxis: {
          type: "value",
          min: this.minNum,
          max: this.maxNum,
          splitNumber: 5,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#e7eef6"
            },
            onZero: false
          },
          axisLabel: {
            fontSize: 12,
            color: "#90939a",
            interval: 0
          },
          splitLine: {
            lineStyle: {
              color: "#e7eef6"
            }
          },
          scale: true
        },
        series: [
          {
            data: this.lineNum,
            type: "line",
            color: "#fff",
            symbol: "circle",
            symbolSize: 6,
            smooth: true, //平滑曲线连接
            itemStyle: {
              normal: {
                color: "#2568ff"
              }
            },
            lineStyle: {
              color: {
                type: "radial",
                x: 0,
                y: 0,
                r: 5,
                colorStops: [
                  {
                    offset: 0,
                    color: "#008afd" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#4446fb" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              width: 3
            },
            areaStyle: {
              normal: {
                color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#9bb5f8"
                  },
                  {
                    offset: 1,
                    color: "#fff"
                  }
                ])
              }
            }
          }
        ]
      };
      this.line.setOption(optionL);
    },
    //提交按钮点击事件
    handlesSubmitForm() {
      this.$refs.searchForm.submitForm().then(valid => {
        if (valid) {
          this.FetchFindByPage(this.formExtend.forms);
        }
      });
    },
    /**
     *  初始化企业
     */
    initAllComparys() {
      FetchAllComparys()
        .then(response => {
          if (
            response.result &&
            response.result &&
            Array.isArray(response.result)
          ) {
            this.allComparys = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //企业综合信用得分颜色
    setScoreColor(score) {
      if (score >= 90) {
        return "score-1";
      } else if (score >= 75) {
        return "score-2";
      } else if (score >= 60) {
        return "score-3";
      } else {
        return "score-4";
      }
    },
    //企业行为分析中得分颜色
    setColor(row) {
      if (row.behavioralScore >= row.totalAverage) {
        return "isgreen";
      } else {
        return "isred";
      }
    }
  },
  created() {
    let param = this.$route.query;
    if (Object.keys(param).length) {
      this.initAllComparys();
      this.firstEnter = false;
      this.formExtend.forms.comparyId = Number(param.id);
      this.formExtend.forms.beginTime = Number(param.bTime);
      this.formExtend.forms.endTime = Number(param.eTime);
      this.FetchFindByPage(this.formExtend.forms);
    } else {
      this.firstEnter = true;
      this.initAllComparys();
    }
  },
  mounted() {
    this.initRadarChart();
    this.initLineChart();
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/iconFont/iconfont.css";
@import "../../../assets/styles/compary-detail.scss";
</style>
